module.exports = __webpack_public_path__ + "img/Dantam Hair 09.9d3930a8.jpg";